/* MolCellQuest — 認証状態のリアクティブな入れ物
   ──────────────────────────────────────────────────────────
   online.js は素の .js で、$state（Svelte のコンパイル時機能）を
   持てない。各コンポーネントが installBridge して自前のカウンタを
   回すのは煩雑なので、ここで1回だけ購読して $state に写す。
   UI からは auth.user を見るだけでよい。
   ────────────────────────────────────────────────────────── */

import { installBridge, getAuthState } from "./online.js";

export const auth = $state({
  user: null,
  syncEnabled: false,
  reason: "loading",
});

let started = false;

/** App.svelte から1度だけ呼ぶ */
export function initAuthState() {
  const pull = () => Object.assign(auth, getAuthState());
  if (!started) {
    started = true;
    installBridge(pull);
  }
  pull();
}

/** ログイン済みか（アカウント限定機能の判定はここに集約する） */
export function isSignedIn() {
  return !!auth.user;
}
